import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchRenewalRequestAPI,
  submitRenewalRequestAPI,
  submitRenewalRequestZeroFee,
} from "../services/apiEndpoints";

export const submitRenewalRequestThunk = createAsyncThunk(
  "renewal/submitRequest",
  async (payload: any, thunkAPI) => {
    try {
      const response = await submitRenewalRequestAPI(payload);
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message ||
          error?.response?.data?.errors?.[0] ||
          error.message ||
          "Submit Failed",
      );
    }
  },
);

export const fetchRenewalRequestThunk = createAsyncThunk(
  "renewal/fetchRequest",
  async (applicationId: any, thunkAPI) => {
    try {
      const response = await fetchRenewalRequestAPI(applicationId);
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message ||
          error?.response?.data?.errors?.[0] ||
          error.message ||
          "Submit Failed",
      );
    }
  },
);

export const submitRenewalRequestZeroFeeThunk = createAsyncThunk(
  "renewal/submitRequestZeroFee",
  async (applicationId: any, thunkAPI) => {
    try {
      const response = await submitRenewalRequestZeroFee(applicationId);
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message ||
          error?.response?.data?.errors?.[0] ||
          error.message ||
          "Submit Failed",
      );
    }
  },
);
